const ENABLED = process.env.NODE_ENV === 'development';

export const bootstrapDebug = (step: string, detail?: Record<string, unknown>): void => {
    if (!ENABLED) {
        return;
    }
    if (detail) {
        console.info('[MySkladon bootstrap]', step, detail);
    } else {
        console.info('[MySkladon bootstrap]', step);
    }
};
